import React from 'react';
import StickyMessage from '../../shared/components/sticky-message';
import { Helpers } from '../../core/src/helpers';


/**
 * Script loader loaders scripts and store in redux. 
 * This is to prevent the script resource being fetched several times on a SPA
 */
export default class PreviewOverlay extends React.Component {


    getPreviewDate = () => {
        const { previewParam} = this.props;
        try{
            const [,,date] = atob(decodeURIComponent(previewParam)).split("|");
            return new Date(date * 1).toGMTString();
        }catch(e){}
        return null;
    }

    render() {
        const { slugInfo } = this.props;
        const { key, seo: { redirectTo }} = slugInfo;
        let previewDate = this.getPreviewDate();

        return(
                <StickyMessage title="Preview Mode" onClick={this.onClick}>
                    <p>
                        {`You are currently previewing ${slugInfo.key}`}
                    </p>
                    {previewDate && <p>{`As of ${previewDate}`}</p>}
                    {redirectTo && (
                        <p>
                            <b>Important</b>: Customers visiting this page will be redirected to following URL: <a href={redirectTo}>{redirectTo}</a>
                        </p>
                    )}
                </StickyMessage>
        )
    }
}
